import script from "./orderRemark.vue?vue&type=script&setup=true&lang=js"
export * from "./orderRemark.vue?vue&type=script&setup=true&lang=js"

import "./orderRemark.vue?vue&type=style&index=0&id=0830920d&lang=scss"

const __exports__ = script;

export default __exports__